<div class="collisionForm-component">
    COLLISION FORM
</div>